import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      // Litet dröjsmål så bannern glider in efter sidladdning, inte direkt
      const timer = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleChoice = (choice) => {
    localStorage.setItem('cookie_consent', choice);
    localStorage.setItem('cookie_consent_date', new Date().toISOString());
    setVisible(false);

    // Här kan du koppla på/av spårningsskript baserat på valet, t.ex:
    // if (choice === 'accepted' && window.gtag) {
    //   window.gtag('consent', 'update', { analytics_storage: 'granted' });
    // }
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie-samtycke">
      <div className="cookie-banner-content">
        <p className="cookie-banner-text">
          Vi använder cookies för att förbättra din upplevelse och analysera trafik på vår sida.
          Läs mer i vår <a href="/integritetspolicy">integritetspolicy</a>.
        </p>
        <div className="cookie-banner-buttons">
          <button
            className="cookie-btn cookie-btn-decline"
            onClick={() => handleChoice('declined')}
          >
            Avböj
          </button>
          <button
            className="cookie-btn cookie-btn-accept"
            onClick={() => handleChoice('accepted')}
          >
            Acceptera
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
